import { Group } from "@mantine/core"
import { valueToThemeColor } from "../utils"
import classes from "./Question.module.css"
import { ButtonQuestion } from "./QuestionButton"
import { QuestionPercent } from "./QuestionPercent"
import type { TQuestionProps } from "./types"
import { useScaleValue } from "./utils"

const MARKS = {
  scale5: [1, 2, 3, 4, 5],
  scale10: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
}

export function QuestionScale(props: TQuestionProps) {
  const { question, value, setValue, preview } = props
  const { type, meta } = question
  const scaleType = type == "scale" ? meta?.category : type

  const marks = MARKS[scaleType]
  const { color, value: parsedValue, process } = useScaleValue(question, value)

  if (scaleType == "percent") {
    return <QuestionPercent {...props} />
  }

  return (
    <Group gap="xs">
      {marks.map((mark: number) => (
        <ButtonQuestion
          px="md"
          flex="0 0 60px"
          key={mark}
          preview={preview}
          classNames={classes}
          onClick={() => setValue(process(mark))}
          color={parsedValue === mark ? color : "gray"}
          variant={parsedValue === mark ? "filled" : "outline"}
          style={{ "--color-hover": `var(--mantine-color-${valueToThemeColor(process(mark))}-5)` }}
        >
          {mark}
        </ButtonQuestion>
      ))}
    </Group>
  )
}
